import { loader } from 'graphql.macro'

export default function recurringTicketsQuery ({ dataLoaders, queryKey }) {
  const [, jobId, first, pager = null] = queryKey

  let graphQLVariables = {
    jobId,
    first
  }
  if (pager) {
    const paginatedVariables = {
      before: pager.direction === 'before' ? pager.cursor : null,
      after: pager.direction === 'after' ? pager.cursor : null,
      first: pager.direction === 'after' ? Number(pager.pageSize) : null,
      last: pager.direction === 'before' ? Number(pager.pageSize) : null
    }
    graphQLVariables = { ...graphQLVariables, ...paginatedVariables }
  }

  const recurringTicketsQuery = loader('./recurringTickets.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(recurringTicketsQuery, graphQLVariables)
}
